// extracted by mini-css-extract-plugin
module.exports = {"richEditorContainer":"richEditor_richEditorContainer__aorYt","boxStyles":"richEditor_boxStyles__k0xIf"};